export default "__VITE_ASSET__Cp9Osb9i__"